/**
 * Small, self-contained render-helper functions extracted verbatim (no
 * logic changes) from EvidenceTable.tsx purely to reduce the size of the
 * main component file. Each function receives explicit parameters for
 * every value it needs (props/state/callbacks) instead of relying on
 * `this`, so behavior is identical to the original inline class methods.
 */
import React from "react";
import { Cell, Column } from "fixed-data-table-2";
import { EvidencePeriodData, Student } from "../../../../../../store/onboarding/types";
import StudentGroupIconOverlay from "../student-data-table/StudentGroupIconOverlay";

// Extracted verbatim from EvidenceTable.getStudentGroupIconColumn
export const renderStudentGroupIconColumn = (
  isPlanning: boolean | undefined,
  evidencePeriodData: EvidencePeriodData | undefined,
  studentInterventionGroups: any
) => {
  return isPlanning ? (
    <Column
      allowCellsRecycling
      fixed={true}
      width={10}
      cell={(props) => {
        const student = evidencePeriodData!.student_rows[props.rowIndex].student;
        return (
          <Cell className="blueStrip">
            <StudentGroupIconOverlay
              interventionGroups={studentInterventionGroups}
              student={student}
            />
          </Cell>
        );
      }}
    />
  ) : (
    <Column width={0} />
  );
};

// Extracted verbatim from EvidenceTable.getStudentCheckColumn
export const renderStudentCheckColumn = (
  isPlanning: boolean | undefined,
  evidencePeriodData: EvidencePeriodData | undefined,
  newGroupStudents: Array<Student>,
  selectedStudents: Array<Student>,
  handleStudentCheck: (student: Student) => (event: React.ChangeEvent<any>) => void
) => {
  return isPlanning ? (
    <Column
      allowCellsRecycling
      fixed={true}
      width={30}
      cell={(props) => {
        const student = evidencePeriodData!.student_rows[
          props.rowIndex
        ].student;

        student.grade = evidencePeriodData!.student_rows[
          props.rowIndex
        ].grade;

        if(student.grade ==  null) {
          evidencePeriodData!.evidence_column_groups
          .map((evidence_column_groups) => {
            return evidence_column_groups.evidence_columns.map((evidenceColumn) => {
              return evidenceColumn.student_entries.map((studentEntry) => {
                student.grade = studentEntry.grade;
                return student;
              })
            })
          })
        }
        return (
          <Cell>
            {(!newGroupStudents.some(
              (s) => s.id === student.id
            )) && (
                <input
                  checked={selectedStudents.some(
                    (selectedStudent) => selectedStudent.id === student.id
                  )}
                  onChange={handleStudentCheck(student)}
                  type="checkbox"
                  key={student.id}
                />
              )}
          </Cell>
        );
      }}
    />
  ) : (
    <Column width={0} />
  );
};
